// plugins/catalog-filter-tokens.global.js
import { useCatalogFilterTokens } from '@/composables/useCatalogFilterTokens';

export default defineNuxtPlugin(async () => {
  const { tokens, reset, ensureLoaded } = useCatalogFilterTokens();

  if (import.meta.server) {
    reset();
    await ensureLoaded({ force: true });
    return;
  }

  // SSR may have hydrated with tokens still null (e.g. the upstream fetch
  // failed for that request). Retry once on the client so catalog URL
  // parsing doesn't stay stuck on the empty fallback for the rest of the
  // session — ensureLoaded() is a no-op if tokens already loaded and fresh.
  if (!tokens.value) {
    await ensureLoaded();
  }
});
